
import React from 'react';
import { MealInfo } from '../daily-tile';

interface StatusDotProps {
  meals: MealInfo[];
}

const StatusDot: React.FC<StatusDotProps> = ({ meals }) => {
  const getDotColor = () => {
    if (meals.length === 0) return 'bg-gray-300';
    if (meals.length === 1) {
      return meals[0].type === 'recipe' ? 'bg-blue-500' : 'bg-purple-500';
    }
    return 'bg-green-500';
  };

  const getTooltipText = () => {
    if (meals.length === 0) return 'No meals planned';
    return `${meals.length} meal${meals.length !== 1 ? 's' : ''} planned`;
  };

  return (
    <div className="flex justify-end mt-2">
      <div 
        className={`w-2 h-2 rounded-full ${getDotColor()}`}
        title={getTooltipText()}
      />
    </div>
  );
};

export default StatusDot;
